module.exports = __webpack_public_path__ + "img/P150T_weapon_143.2ba93caf.png";